export enum AgreementTypeEnum {
  PersonalData = 'personalDataAgreement',
  MarketingUsage = 'marketingUsageAgreement'
}
